import { useEffect, useRef, useState } from 'react';
import { DsButton } from '@/modules/internal-v2/ds';
import type { EmailBlockType } from '@/api/email-builder/email-builder.types.ts';
import { BLOCK_GROUPS, BLOCK_TYPE_META } from '../email-builder.constants';

interface AddBlockMenuProps {
  onAdd: (type: EmailBlockType) => void;
}

/** "+ Block hinzufügen" trigger with a grouped block-type picker panel. */
export function AddBlockMenu({ onAdd }: AddBlockMenuProps) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const onClickOutside = (e: MouseEvent) => {
      if (!rootRef.current?.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, [open]);

  return (
    <div className="eb-add" ref={rootRef}>
      <DsButton
        type="button"
        variant="primary"
        className="eb-add-trigger"
        aria-expanded={open}
        onClick={() => setOpen((value) => !value)}
      >
        + Block hinzufügen
      </DsButton>

      {open && (
        <div className="eb-add-menu" role="menu">
          {BLOCK_GROUPS.map((group) => (
            <div key={group.group} className="eb-add-group">
              <span className="eb-add-group-label">{group.group}</span>
              {group.types.map((type) => {
                const meta = BLOCK_TYPE_META[type];
                return (
                  <button
                    type="button"
                    key={type}
                    role="menuitem"
                    className="eb-add-item"
                    onClick={() => {
                      onAdd(type);
                      setOpen(false);
                    }}
                  >
                    <span className="eb-add-item-label">{meta.label}</span>
                    <span className="eb-add-item-desc">{meta.description}</span>
                  </button>
                );
              })}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
